export enum AlertTypes {
    info,
    warning,
    error,
    success
}
